import PrivateTemplate from './PrivateTemplate'

export default PrivateTemplate
